import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import {
  AircraftMakeModelActions,
  AircraftMakeModelActionTypes,
} from './aircraft-make-model.actions';
import { AircraftMakeModelEntity } from './aircraft-make-model.model';

export interface AircraftMakeModelEntities extends EntityState<AircraftMakeModelEntity> {
  // additional entities state properties
}

export const adapter: EntityAdapter<AircraftMakeModelEntity> = createEntityAdapter<
  AircraftMakeModelEntity
>();

export const initialState: AircraftMakeModelEntities = adapter.getInitialState({
  // additional entity state properties
});

export function reducer(state = initialState, incomingAction: Action): AircraftMakeModelEntities {
  const action = incomingAction as AircraftMakeModelActions;
  switch (action.type) {
    case AircraftMakeModelActionTypes.AddAircraftMakeModel: {
      return adapter.addOne(action.payload.aircraftMakeModel, state);
    }

    case AircraftMakeModelActionTypes.UpsertAircraftMakeModel: {
      return adapter.upsertOne(action.payload.aircraftMakeModel, state);
    }

    case AircraftMakeModelActionTypes.AddAircraftMakeModels: {
      return adapter.addMany(action.payload.aircraftMakeModels, state);
    }

    case AircraftMakeModelActionTypes.UpsertAircraftMakeModels: {
      return adapter.upsertMany(action.payload.aircraftMakeModels, state);
    }

    case AircraftMakeModelActionTypes.UpdateAircraftMakeModel: {
      return adapter.updateOne(action.payload.aircraftMakeModel, state);
    }

    case AircraftMakeModelActionTypes.UpdateAircraftMakeModels: {
      return adapter.updateMany(action.payload.aircraftMakeModels, state);
    }

    case AircraftMakeModelActionTypes.DeleteAircraftMakeModel: {
      return adapter.removeOne(action.payload.id, state);
    }

    case AircraftMakeModelActionTypes.DeleteAircraftMakeModels: {
      return adapter.removeMany(action.payload.ids, state);
    }

    case AircraftMakeModelActionTypes.LoadAircraftMakeModels: {
      return adapter.setAll(action.payload.aircraftMakeModels, state);
    }

    case AircraftMakeModelActionTypes.ClearAircraftMakeModels: {
      return adapter.removeAll(state);
    }

    default: {
      return state;
    }
  }
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
